import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { WithApp } from 'contexts/appContext';
import { wsGetAll, wsFindBy } from 'services/WService.js';

const tipos = [
  { code: 'O', label: 'Venta' },
  { code: 'I', label: 'Compra' },
  { code: 'C', label: 'Cobertura' },
];
const ZONALES = ['NORTE', 'SUR'];

export default WithApp(function ModalCuotaSupervisor(props) {
  const cuota = props.model;
  const periodo = moment(cuota.valueSearch?.Periodo).format('YYYY-MM');

  const [dataChanging, setDataChanging] = useState([]);
  const [supervisors, setSupervisors] = useState([]);

  function handleChange(field, value) {
    setDataChanging((prev) => ({ ...prev, [field]: value }));
  }

  async function listSupervisors() {
    let response = await wsFindBy('base/boss-supervisor', { state: 'A', deleted: 'null' });
    if (response.success) setSupervisors(response.data);
  }

  useEffect(() => {
    if (supervisors.length > 0 && cuota.base_boss_supervisor_id) {
      handleChange('base_boss_supervisor_id', String(cuota.base_boss_supervisor_id));
    }
  }, [supervisors]);

  useEffect(() => {
    if (cuota.open) {
      setDataChanging({
        ...(cuota.zonal ? { zonal: cuota.zonal } : {}),
        type: cuota.type,
      });
      listSupervisors();
    }
  }, [cuota.open]);

  return (
    <>
      <Modal
        title={`Nueva cuota de supervisor winter`}
        model={cuota}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity='sale/winter_quota_boss_supervisors'
        dataForce={{
          zonal: dataChanging.zonal,
          base_boss_supervisor_id: dataChanging.base_boss_supervisor_id,
          type: dataChanging.type,
        }}
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="Periodo"
          margin="normal"
          defaultValue={periodo || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <Autocomplete
          disableClearable
          options={ZONALES}
          getOptionLabel={(item) => `${item}`}
          renderInput={(params) => (
            <TextField {...params} label="Zonal" margin="normal" fullWidth />
          )}
          onChange={(e, item) => { handleChange('zonal', item); }}
          value={ZONALES.find((z) => z === dataChanging.zonal) || null}
          style={{ flexGrow: 1, marginRight: '10px' }}
        />
        <Autocomplete
          disableClearable
          options={supervisors}
          getOptionLabel={(item) => `${item.name}`}
          renderInput={(params) => (
            <TextField {...params} label="Jefe de venta" margin="normal" fullWidth />
          )}
          onChange={(e, item) => { handleChange('base_boss_supervisor_id', item?.id); }}
          value={supervisors.find((sup) => String(sup.id) === String(dataChanging.base_boss_supervisor_id)) || null}
          style={{ flexGrow: 1, marginRight: '10px' }}
        />
        <Autocomplete
          disableClearable
          options={tipos}
          getOptionLabel={(item) => item.label}
          renderInput={(params) => (
            <TextField {...params} label="Tipo" margin="normal" fullWidth />
          )}
          onChange={(e, item) => { handleChange('type', item?.code); }}
          value={tipos.find((t) => t.code === dataChanging.type) || null}
          style={{ flexGrow: 1, marginRight: '10px' }}
        />
        <TextField
          label="Cuota"
          fullWidth
          type="number"
          name="quota"
          margin="normal"
          defaultValue={!!cuota ? cuota.quota : ''}
          required
        />
      </Modal>
    </>
  );
});
